import { PhoneField, TextField, SubmitFormButton, useFormContext } from '@calendly/form';
import { Fieldset } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { getTimezoneName } from '@calendly/timezone-tools';
import { Button } from '@calendly/ui/components/button';
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { countryCodeSelector } from 'selectors/current_user';
import { TimezonePicker } from './timezone_picker';
const styledFieldSetCss = "s1d6ezjm";
const StyledFieldSet = forwardRef((props, ref) => <Fieldset ref={ref} {...props} className={classNames(styledFieldSetCss, props.className)} />);
const profileFormContainerCss = "peaceln";
const ProfileFormContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(profileFormContainerCss, props.className)} />;
});
const profileFormSectionCss = "pydc3q8";
const ProfileFormSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(profileFormSectionCss, props.className)} />;
});
const styledTextInputCss = "sgn89qz";
const StyledTextInput = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(styledTextInputCss, props.className)} />);
const buttonsContainerCss = "b1a0g66v";
const ButtonsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonsContainerCss, props.className)} />;
});
const styledButtonCss = "s147yq4j";
const StyledButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
export const ContactFormFields = ({
  handleClose,
  showEditContactForm
}) => {
  const {
    values
  } = useFormContext();
  const countryCode = useSelector(countryCodeSelector);
  return <StyledFieldSet>
      <ProfileFormContainer>
        <ProfileFormSection>
          <FullStoryExclude>
            <StyledTextInput autoFocus name="name" label={I18n.t('publisher.contacts.name')} type="text" required />
          </FullStoryExclude>
          {showEditContactForm ? <FullStoryExclude>
              <StyledTextInput name="email" label={I18n.t('publisher.contacts.email')} type="text" required disabled />
            </FullStoryExclude> : <FullStoryExclude>
                <StyledTextInput name="email" label={I18n.t('publisher.contacts.email')} type="text" required />
              </FullStoryExclude>}
          <TimezonePicker name="time_zone" defaultOptionLabel={getTimezoneName(values.time_zone) || I18n.t('publisher.contacts.timezone')} />
          <FullStoryExclude>
            <PhoneField name="phone" label={I18n.t('publisher.contacts.phone')} countryCode={countryCode} />
          </FullStoryExclude>
        </ProfileFormSection>
      </ProfileFormContainer>
      <ButtonsContainer>
        <StyledButton decoration="ghost" onClick={handleClose}>
          {I18n.t('publisher.contacts.buttons.cancel')}
        </StyledButton>
        <SubmitFormButton>
          {I18n.t('publisher.contacts.buttons.save_and_close')}
        </SubmitFormButton>
      </ButtonsContainer>
    </StyledFieldSet>;
};

require("./contact_form_fields.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./contact_form_fields.js");